import axiosInstance from "../../common/axios";

export function contactAPI(values) {
  return axiosInstance.post(`api/contact/`, values);
}